import requestor from "shared/service/requestor";

export default class CollaborationApi {
  search(email) {
    return requestor.get("/collaboration/search", {
      email: email,
    });
  }

  partner = {
    all: (date_from = "", date_to = "") =>
      requestor.get("/collaboration/partner_all", {
        filter: {
          date_from: date_from,
          date_to: date_to,
        },
      }),
    selfData: (date_from = "", date_to = "") =>
      requestor.get("/collaboration/self_partner_data", {
        filter: {
          date_from: date_from,
          date_to: date_to,
        },
      }),
    catalogLink: (project_id) =>
      requestor.get("/collaboration/catalog_link", {
        project_id,
      }),
  };

  coauthor = {
    all: (date_from = "", date_to = "") =>
      requestor.get("/collaboration/coauthor_all", {
        filter: {
          date_from: date_from,
          date_to: date_to,
        },
      }),
    selfData: (date_from = "", date_to = "") =>
      requestor.get("/collaboration/self_coauthor_data", {
        filter: {
          date_from: date_from,
          date_to: date_to,
        },
      }),
  };

  referral = {
    info: () => requestor.get("/referral/info"),
    partners: () => requestor.get("/referral/partners"),
    statistics: (id) =>
      requestor.get("/referral/statistics", {
        referral_id: id,
      }),
  };
}
